<template>
  <div class="container">
    <h2>Piva</h2>
    <div class="row no-gutters justify-content-center">
      <div v-for="item in standard" :key="item.id" class="col-xl-3 col-lg-4 col-md-6">
        <Item :item="item" />
      </div>
    </div>

    <h2>Experimentální várky</h2>
    <div class="row no-gutters justify-content-center experimental">
      <div v-for="item in experimental" :key="item.id" class="col-xl-3 col-lg-4 col-md-6">
        <Item :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import Item from "../components/Item";

export default {
  name: "Items",
  components: {
    Item,
  },
  data: () => ({
    standard: [],
    experimental: [],
  }),
  created() {
    var self = this;
    fetch(this.$apipath + "/api/items")
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          return response.text().then((text) => {
            throw new Error("\nHTTP " + response.status + " - " + text);
          });
        }
      })
      .then((data) => {
        let experimental = data.filter((elem) => elem.name.startsWith("[Experimentální]"));
        let standard = data.filter((elem) => !elem.name.startsWith("[Experimentální]"));
        self.standard = standard.sort(function(a, b) {
          return self.compareState(a.state) - self.compareState(b.state);
        });
        self.experimental = experimental.sort(function(a, b) {
          return self.compareState(a.state) - self.compareState(b.state);
        });
      })
      .catch((err) => {
        self.$store.commit("addNotification", {
          text: "Chyba načtení položek zkontroluje připojení a akci zopakujte. " + err.message,
          type: "alert",
        });
      });
  },
  methods: {
    compareState(state) {
      switch (state) {
        case "NEW":
          return 0;
        case "AVAILABLE":
          return 1;
        case "COMING_SOON":
          return 2;
        case "NOT_AVAILABLE":
          return 3;
        default:
          return 1000;
      }
    },
  },
};
</script>
